import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import { DuLieuHeThong } from 'api';

class DropDownKetQuaGiaiQuyet extends React.Component {
  constructor(props, context) {
    super(props);
    this.state = {
      data: this.props.data
    }
  }

  componentDidMount() {
    if(this.props.data.length == 0) {
      DuLieuHeThong.actions.getKetQuaGiaiQuyet.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'ketQuaGiaiQuyet',
            data: res.data || []
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown label={this.props.label } selectedValue={this.props.selectedValue} options={ this.state.data } keyName='giaTri' valueName='ten' className={this.props.className} onChange={ this.onChange.bind(this) } placeholder={ this.props.placeholder } />
    );
  }
}

DropDownKetQuaGiaiQuyet.defaultProps = {
  label: 'Kết quả xử lý',
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: [],
  data: []
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.ketQuaGiaiQuyet
  }
}

export default connect(bindStateToProps)(DropDownKetQuaGiaiQuyet);


// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-ketquagiaiquyet.jsx